import { MAX_LOAN_AMOUNT } from "@component/PersonalLoan/Calculator/data";
import type { AbstractStepProps } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { AbstractStep } from "@component/assets/AbstractLeadForm/Steps/AbstractStep";
import { faArrowRight as fasArrowRight } from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { formatText } from "@ui/format";
import { Button, FormCurrency, FormDate, FormDecidable } from "bm-ui-kit";
import dayjs from "dayjs";
import type { FormApi } from "final-form";
import type { ReactNode } from "react";
import React from "react";
import { Card } from "react-bootstrap";

export interface StepFields {
	hasBothOfTheCoupleHunAddress: boolean;
	birthDate: string;
	isLast180daysSocInHun: boolean;
	loanAmount: number;
}

interface Props extends AbstractStepProps {
	hasEitherOfCoupleSocialInsurance: boolean;
}

export class Step5 extends AbstractStep<StepFields, Props> {
	protected initValues(): StepFields {
		return {
			hasBothOfTheCoupleHunAddress: undefined,
			birthDate: undefined,
			isLast180daysSocInHun: undefined,
			loanAmount: undefined,
		};
	}

	protected renderContent(_values: StepFields, form: FormApi<StepFields>): ReactNode {
		const { hasEitherOfCoupleSocialInsurance } = this.props;

		return (
			<>
				<Card.Header>
					<div className="h4 text-center mb-0">Babaváró hitelt csak házaspárok igényelhetnek!</div>
				</Card.Header>
				<Card.Body>
					<FormDecidable
						label="Mindkettőtöknek van magyar lakcíme?"
						name="hasBothOfTheCoupleHunAddress"
						required
					/>
					<FormDate
						label="A pár hölgy tagja mikor született?"
						name="birthDate"
						autoComplete="bday"
						validate={this.validBirthDate}
						required
					/>
					{hasEitherOfCoupleSocialInsurance && (
						<FormDecidable
							label="Az utolsó 180 nap TB jogviszony magyar alkalmazotti, vállalkozói jogviszonyból származik?"
							name="isLast180daysSocInHun"
							infoTooltip="Amennyiben külföldi TB jogviszonyt igazoltál le, akkor elégséges, ha az utolsó 90 nap származik magyar alkalmazotti, vállalkozói jogviszonyból."
							required
						/>
					)}
					<FormCurrency
						label="Mennyi Babaváró hitelt szeretnétek igényelni?"
						name="loanAmount"
						infoTooltip="A Babaváró hitel maximális összege 10 millió Ft."
						placeholder="Add meg a hitelösszeget!"
						validate={this.validLoanAmount}
						required
					/>
				</Card.Body>
				<Card.Footer className="text-center">
					<Button
						type="submit"
						icon={<FontAwesomeIcon icon={fasArrowRight} />}
						className={!form.getState().valid ? "disabled" : undefined}
					>
						Tovább
					</Button>
				</Card.Footer>
			</>
		);
	}

	private validLoanAmount(loanAmount: number): string {
		if (loanAmount < 1) {
			return "Kérjük, add meg a hitelösszeget!";
		}

		if (loanAmount > MAX_LOAN_AMOUNT) {
			return `A hitel maximum ${formatText(MAX_LOAN_AMOUNT, "ft")} lehet.`;
		}

		return undefined;
	}

	private validBirthDate(birthDate: string): string {
		const age = Math.abs(dayjs(birthDate).diff(dayjs(), "year"));

		if (age < 18) {
			return "Kiskorú személy nem igényelhet hitelt!";
		}

		return undefined;
	}

	protected getComponentName(): string {
		return "Step5";
	}
}
